import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.familyType;

const getFamilyType = createSelector(getData, familyType => values(familyType));

export default getFamilyType;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getFamilyType.js